var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBtn)?_c('ColorTextBtn',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.linkToAddCustomFloor}},[_vm._v(" 编辑 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }